import MUIDataTable, { MUIDataTableColumn, MUIDataTableOptions, MUIDataTableProps } from "mui-datatables"
import { underwritingOptions } from "../../../constants/underwritingOptions"
import Loading from "../../atoms/Loading"
type WithLoading<T> = { loading?: false } & T | { loading: true }

export type UnderwritingTableBase = Pick<MUIDataTableProps, "data"> & {
    title: string,
    onRowClick: (pathId: number) => void
    options?: MUIDataTableOptions,
    columns: MUIDataTableColumn[]
}





const UnderwritingTable: React.FunctionComponent<WithLoading<UnderwritingTableBase>> = (props) => {
    if (props.loading) {
        return (
            <Loading />
        )
    }

    return (
        <MUIDataTable
            title={props.title}
            data={props.data}
            columns={props.columns}
            options={{
                ...underwritingOptions, ...props.options, onRowClick: (rowData) => {
                    const targetId = parseInt(rowData[0]);
                    props.onRowClick(targetId)
                },
                sort: true,
            }} />
    )

}






export default UnderwritingTable